const version = "2.3.5";

export { version };
//# sourceMappingURL=version.mjs.map
